// The predicate return type is what lets callers pass the argument straight on to
// `formatDate` and friends: a `null` bound can never reach the `true` branch.
export function isDateValid(dateStr: number | Date | string | null): dateStr is number | Date | string {
  return !(dateStr === null || isNaN(new Date(dateStr)?.getTime()));
}
